import React, { useState, useEffect, useCallback } from 'react';
import { useWeb3 } from '../context/Web3Context';
import { useLanguage } from '../i18n/LanguageContext';
import { getConfig } from '../utils/config';
import { Web3 } from 'web3';
import MintNFT from '../components/MintNFT';
import MyNFTs from '../components/MyNFTs';
import NFTMarketplaceComponent from '../components/NFTMarketplaceComponent';
import BFPENFTABI from '../contracts/BFPENFT.json';
import NFTMarketplaceABI from '../contracts/NFTMarketplace.json';

const NFTPage = () => {
  const { web3, account } = useWeb3();
  const { t } = useLanguage();
  const [nftContract, setNftContract] = useState(null);
  const [marketplaceContract, setMarketplaceContract] = useState(null);
  const [refreshSignal, setRefreshSignal] = useState(0);
  const triggerRefresh = useCallback(() => setRefreshSignal(s => s + 1), []);

  const config = getConfig();
  const nftContractAddress = config.NFT_CONTRACT_ADDRESS;
  const marketplaceContractAddress = config.MARKETPLACE_CONTRACT_ADDRESS;

  useEffect(() => {
    initContracts();
  }, [web3]);

  const initContracts = async () => {
    if (!web3) return;

    try {
      if (nftContractAddress && nftContractAddress !== '') {
        const nft = new web3.eth.Contract(BFPENFTABI.abi, nftContractAddress);
        setNftContract(nft);
      }

      if (marketplaceContractAddress && marketplaceContractAddress !== '') {
        const marketplace = new web3.eth.Contract(NFTMarketplaceABI.abi, marketplaceContractAddress);
        setMarketplaceContract(marketplace);
      }
    } catch (err) {
      console.error('Error initializing NFT contracts:', err);
    }
  };

  if (!nftContractAddress || nftContractAddress === '') {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="card">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('nftPage.configTitle')}</h2>
            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-800">
                <strong>{t('nftPage.configMessage')}</strong>
              </p>
              <pre className="text-xs text-yellow-700 mt-2 bg-yellow-100 p-2 rounded">
                VITE_NFT_CONTRACT_ADDRESS=tu_direccion_del_contrato_nft{'\n'}
                VITE_MARKETPLACE_CONTRACT_ADDRESS=tu_direccion_del_marketplace
              </pre>
              <p className="text-xs text-yellow-700 mt-2">
                {t('nftPage.configNote')} <code className="bg-yellow-100 px-1 rounded">npm run deploy:nft</code> {t('nftPage.configNote2')}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">{t('nftPage.title')}</h1>
          <p className="text-lg text-white/90">{t('nftPage.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          <MintNFT nftContract={nftContract} nftContractAddress={nftContractAddress} onMinted={triggerRefresh} />
          <MyNFTs 
            nftContract={nftContract} 
            marketplaceContract={marketplaceContract}
            nftContractAddress={nftContractAddress}
            marketplaceContractAddress={marketplaceContractAddress}
            refreshSignal={refreshSignal}
            onRefresh={triggerRefresh}
          />
        </div>

        <div className="mb-6">
          <NFTMarketplaceComponent 
            nftContract={nftContract} 
            marketplaceContract={marketplaceContract}
            nftContractAddress={nftContractAddress}
            marketplaceContractAddress={marketplaceContractAddress}
            refreshSignal={refreshSignal}
            onRefresh={triggerRefresh}
          />
        </div>
      </div>
    </div>
  );
};

export default NFTPage;
